<template>
  <div>
    <div class="main-title">安全员统计表</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-select
              v-model="searchForm.company_ids"
              multiple
              placeholder="选择科目"
              @change="search(searchParams)"
              style="width:250px;">
              <el-option
                v-for="item in companyList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="searchForm.daterange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :disabled="user.buttons.indexOf(1020) < 0"
              :picker-options="datePickerOptions"
              @change="search(searchParams)">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索安全员姓名或拼音"
              v-model="searchForm.query"
              prefix-icon="el-icon-search"
              clearable
              @input="inputSearch(searchParams)">
            </el-input>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
          <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
          <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
        </el-button-group>
      </div>
      <el-table
        ref="table"
        :data="list"
        stripe
        border
        :height="tableHeight"
        :summary-method="getSummaries"
        show-summary
        style="width:100%">
        <el-table-column
          prop="secu_name"
          label="安全员"
          width="80">
        </el-table-column>
        <el-table-column
          prop="use_time"
          label="累计时长"
          width="80">
        </el-table-column>
        <el-table-column
          prop="student_count"
          label="累计学员"
          width="80">
        </el-table-column>
        <el-table-column
          prop="fee"
          label="累计应收"
          width="80">
        </el-table-column>
        <el-table-column
          prop="fee_discount"
          label="累计优惠"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_total"
          label="累计实收"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_cash"
          label="现金"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_alipay"
          label="支付宝"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_wechat"
          label="微信支付"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_pos"
          label="银行卡"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_balance"
          label="充值卡"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_coupon"
          label="代金券"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_virtual"
          label="挂账"
          width="80"
          v-if="user.pay_virtual == '1'">
        </el-table-column>
        <el-table-column
          prop="pay_advance"
          label="预收"
          width="80"
          v-if="user.pay_advance == '1'">
        </el-table-column>
        <el-table-column
          prop="fee_invalid"
          label="累计作废"
          width="80">
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="120">
          <template slot-scope="scope">
            <el-button type="text" @click="showDetail(scope.row)">查看明细</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[minPageSize, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <detail-dialog :user="user" :visible="detailVisible" :params="detailParams" @close="detailVisible = false"></detail-dialog>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import DatePickerOptions from '../../mixins/DatePickerOptions'
import moment from 'moment'
import DetailDialog from './DetailDialog'
export default {
  mixins: [ListFunc, DatePickerOptions],
  components: {
    DetailDialog
  },
  data () {
    return {
      sqlcode: 'report_secu',
      companyList: [],
      searchForm: {
        company_ids: [],
        query: '',
        daterange: [
          new Date(),
          new Date()
        ]
      },
      detailVisible: false,
      detailParams: {},
      sumProps: [
        'use_time',
        'fee',
        'fee_discount',
        'pay_total',
        'pay_cash',
        'pay_alipay',
        'pay_wechat',
        'pay_balance',
        'pay_coupon',
        'pay_virtual',
        'pay_advance',
        'fee_invalid'
      ]
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout();
    });
  },
  computed: {
    searchParams () {
      if (!this.searchForm.daterange || this.searchForm.daterange.length === 0) {
        return this.searchForm
      } else {
        return {
          company_ids: this.searchForm.company_ids,
          query: this.searchForm.query,
          daterange_start: moment(this.searchForm.daterange[0]).format('YYYY-MM-DD'),
          daterange_end: moment(this.searchForm.daterange[1]).format('YYYY-MM-DD') + ' 23:59:59'
        }
      }
    }
  },
  mounted () {
    this.fetchCompanyList()
  },
  methods: {
    fetchCompanyList () { // 获取考场列表
      this.$http.get('/dbapi/company_combo').then(response => {
        if (response.data.success) {
          this.companyList = response.data.list
          this.searchForm.company_ids = this.companyList.map(c => c.value)
        }
      })
    },
    showDetail (row) {
      this.detailParams = {
        secu_id: row.secu_id,
        company_ids: this.searchForm.company_ids,
        daterange_start: moment(this.searchForm.daterange[0]).format('YYYY-MM-DD'),
        daterange_end: moment(this.searchForm.daterange[1]).format('YYYY-MM-DD') + ' 23:59:59'
      }
      this.detailVisible = true
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        const values = data.map(item => Number(item[column.property]))
        if (this.sumProps.indexOf(column.property) >= 0) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else if (column.property === 'secu_name') {
          sums[index] = '合计'
        } else {
          sums[index] = ''
        }
      })
      return sums
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/report/Secu.vue